<template>
  <div class="course-wrapper" :class="{ expanded: !expanded }">
    <course-header
      v-if="$store.state.app.mainLayoutConfig.header != null"
      :navbarmode.sync="navbarMode"
      :course.sync="course"
      @toggle-team-chat="toggleTeamChat"
      :courseMode="courseMode"
    />

    <div class="course-sidebar">
      <div class="course-sidebar-header">
        <div class="d-flex align-items-center justify-content-between wd-100p">
          <router-link
            v-if="$route.params.bid > 0 || $route.params.iid > 0"
            class="wd-50p d-flex course-name"
            role="button"
            :to="{
              name: 'lmsCourseView',
              params: { id: this.$route.params.id, bid: 0, iid: 0, bot: 0 }
            }"
          >
            <feather type="chevron-left" class="tx-color-02"></feather>
            <div class="text-muted text-uppercase tx-11 pd-t-5">Сургалт</div>
          </router-link>
          <router-link
            v-else
            class="wd-50p d-flex course-name"
            role="button"
            :to="{
              name: 'lmsCourses',
              params: {
                md: courseMode.mode,
                cnm: 'null',
                type: -1,
                d1: 'null',
                d2: 'null'
              }
            }"
          >
            <feather type="chevron-left" class="tx-color-02"></feather>
            <div class="text-muted text-uppercase tx-11 pd-t-5">Сургалтууд</div>
          </router-link>
          <!-- <div class="wd-50p course-percent">
            <div class="progress ht-20">
              <div
                class="progress-bar wd-25p"
                :style="`width: ${course.percent}%`"
                role="progressbar"
              >{{course.percent}}%</div>
            </div>
          </div>-->
        </div>
      </div>
      <div class="course-sidebar-body">
        <!-- <div class="pd-t-20 pd-b-10 pd-x-10">
                <course-nav :boxes="course.boxes"></course-nav>
        </div>-->
        <!-- <course-box
          @toggle-nav="toggleNav"
          :expanded="expanded"
          :boxes="course.boxes"
          :title="course.name"
        ></course-box>-->

        <nav-dynamic
          v-if="rdy"
          @on-rebuy="onRebuy"
          :courseData="course"
          :hasCourseObj="true"
        ></nav-dynamic>
        <!-- <div @click="toggleNav()" class="lms-nav-toggler" role="button">
          <feather :type="expanded?'chevron-left':'chevron-right'"></feather>
        </div>-->
      </div>
    </div>
    <!-- $route.params.bot==493 || -->
    <div
      class="course-content no-header"
      :class="{
        'is-full':
          $route.params.bot == 500 && $route.params.iid > 0 && zoomIsStarted
      }"
      @click="closeLevel2()"
    >
      <!-- <div class="course-content-header">
        <nav aria-label="breadcrumb" class="mg-l-30">
          <ol class="breadcrumb breadcrumb-style3 mg-b-0">
            <li class="breadcrumb-item">
              <router-link
                :to="({ name: 'lmsCourses',  params:{  md: 1,  cnm: 'null',  type:-1, d1: 'null', d2: 'null', }})"
                role="button"
              >Сургалтууд</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link
                :to="({ name: 'lmsCourses',  params:{  md: courseMode.mode,  cnm: 'null',  type:-1, d1: 'null', d2: 'null', }})"
                role="button"
              >{{courseMode.title}}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{course.name}}</li>
          </ol>
        </nav>
      </div>-->
      <div class="course-content-body">
        <div class="d-flex mx-wd-100p-f">
          <div
            :class="
              `main-area wd-${showRightSide ? '75' : '100'}p pos-relative`
            "
          >
            <template v-if="rdy">
              <course-navbar
                @on-toggle-nav="expanded = !expanded"
                @on-toggle-content="toggleContent"
                @on-toggle-right-side="showRightSide = !showRightSide"
                :showRightSide.sync="showRightSide"
                :course="course"
              ></course-navbar>
            </template>
            <div v-if="(mode == 2 || mode == 3) && boxOt == 493 && taskObj.rdy">
              <jitsi-detail
                :course="course"
                :task="taskObj.task"
                @on-jitsi-loaded="cntntNoPdn = true"
              />
            </div>
            <course-certificate v-else-if="mode==-7" :cid="parseInt($route.params.id, 10)" :style="`height: ${getScrollHeight()}`"></course-certificate>
            <vue-custom-scrollbar
              v-else
              :style="`height: ${getScrollHeight()}`"
              :class="`${$store.state.app.isMobile || mode==-7? 'pd-0' : 'pd-15'}`"
            >
              <div v-if="mode == 0 && rdy">
                <course-overview
                  :obj="course"
                  @on-detail="showDetail($event.event, $event.box)"
                  @on-show-exam-result="showExamResult"
                  @show-attach="onAttach"
                  @on-reload="init()"
                />
              </div>
              <div
                v-else-if="mode == 1 && boxObj.rdy"
                class="pd-20 pd-lg-25 pd-xl-30"
              >
                <lesson-list
                  v-if="
                    boxOt == 114 && course.boxes.filter(x => x.ot == 114).length
                  "
                  :tasks="course.boxes.filter(x => x.ot == 114)[0].tasks"
                  @on-detail="showDetail($event)"
                />
                <forum-list
                  v-else-if="boxOt == 124"
                  :tasks="boxObj.box.tasks"
                  @on-detail="showDetail($event, boxObj.box.box)"
                />
            
                <template v-else-if="boxOt == 116 || boxOt == 389 || boxOt == 503">

                <div class="container d-flex justify-content-center ht-100p">
                  <div
                    class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center "
                  >
                    <div class="wd-80p wd-sm-300 mg-b-15">
                      
                      <img v-if="course.percent>100" src="assets/svg/done.svg" class="img-fluid" alt />
                      <img v-else src="assets/svg/zoom.svg" class="img-fluid" alt />
                      
                    </div>
                    <div v-if="course.percent>100" class="tx-16 tx-sm-24 text-muted">Бүх хичээлийг үзэж дуусгалаа</div>
                    <div v-lese class="tx-16 tx-sm-24 text-muted">Хичээл үзэлт ({{course.percent}}%)</div>
                    <p v-if="course.percent>100" class="tx-color-03 mg-b-10 tx-center">
                      Сургалтад үнэлгээ өгөх үү ?
                    </p>
                    <p v-else class="tx-color-03 mg-b-10 tx-center">
                      Та бүх хичээлийг үзэж дуусгаснаар сургалтад үнэлгээ өгөх боломжтой !
                    </p>
                    <task-rating v-if="course.percent>100" :taskId.sync="course.id" @on-rated="rateRdy = false" :allowHalf="true" class="mg-b-30" />
                  </div>
                </div>

                

                  <form-list
                  
                    backTo="course"
                    :forms="boxObj.box.forms"
                    :box="boxObj.box.box"
                    @on-detail="showDetail($event)"
                    @on-show-exam-result="showExamResult"
                  />
                </template>
                <teacher-list
                  v-else-if="boxOt == 396"
                  :tasks="course.teachers"
                  @on-detail="showDetail($event, boxObj.box.box)"
                />
                <zoom-list
                  v-else-if="boxOt == 493 || boxOt == 500"
                  :tasks="boxObj.box.tasks"
                  :course="course"
                  @on-detail="showDetail($event, boxObj.box.box)"
                />
                <assign-list v-else-if="boxOt == 502" :course="course" />
              </div>
              <div v-else-if="mode == 2 || mode == 3">
              <!-- {{ boxOt }} -->
                <forum-topic
                  v-if="boxOt == 124 && taskObj.rdy"
                  :task="taskObj.task"
                  @on-detail="showDetail($event, boxObj.box.box)"
                  @on-toggle-class="toggleBodyClass($event.mode, $event.class)"
                />
                <!--  -->
                <teacher-detail v-if="boxOt == 396" :task="taskObj.task" />
                <form-fill
                  v-if="boxOt == 389"
                  :boxOt="parseInt(boxOt, 10)"
                  backTo="course"
                />
                <template v-if="course.percent == 100">
                  <form-fill
                    v-if="boxOt == 503"
                    :boxOt="parseInt(boxOt, 10)"
                    backTo="course"
                  />
                </template>

                <div v-if="boxOt == 500 && taskObj.rdy">
                  <!-- {{zoomHasNotStarted(taskObj.task)}} -->
                  <div v-if="!zoomIsStarted">
                    <zoom-waiting
                      :task="taskObj.task"
                      :isStarted="zoomIsStarted"
                      :course="course"
                      @on-detail="showTask"
                    />
                  </div>
                  <div v-else-if="taskObj.task.i1 == 0" id="zmmtg-dynamic">
                    <zoom-detail :task="taskObj.task" />
                  </div>
                  <div v-else-if="taskObj.task.i1 == 1" id="zmmtg-dynamic">
                    <zoom-waiting
                      :task="taskObj.task"
                      :isStarted="zoomIsStarted"
                      :course="course"
                      @on-detail="showTask"
                    />
                  </div>
                  <div
                    v-else-if="
                      taskObj.task.i1 == 2 &&
                        hasPermission(['learningteacher', 'learningadmin'])
                    "
                  >
                    <zoom-detail :task="taskObj.task" />
                  </div>
                  <div v-else id="zmmtg-dynamic">
                    <zoom-waiting
                      :task="taskObj.task"
                      :isStarted="zoomIsStarted"
                      :course="course"
                      @on-detail="showTask"
                    />
                  </div>
                </div>
                <div v-if="boxOt == 125 && taskObj.rdy">
                  <forum-reply
                    :id="taskObj.task.id"
                    @on-attach="onAttach"
                  ></forum-reply>
                </div>
              </div>
              <form-fill
                v-else-if="mode == 4 && boxOt == 389"
                backTo="course"
                @on-form-filled="onFormFilled"
                :id="parseInt($route.params.iid, 10)"
                :boxId="parseInt($route.params.bid, 10)"
                :boxOt="parseInt(boxOt, 10)"
                @form-page-rdy="cntntNoPdn = true"
                :prms="
                  course.boxes
                    .filter(x => x.id == $route.params.bid)[0]
                    .forms.filter(f => f.id == $route.params.iid)[0]
                "
              />
              <form-fill
                v-else-if="
                  mode == 4 &&
                    boxOt == 503 &&
                    (course.percent == 100 ||
                      course.boxes.filter(x => x.ot == 114)[0].tasks.length ==
                        0)
                "
                backTo="course"
                @on-form-filled="onFormFilled"
                :id="parseInt($route.params.iid, 10)"
                :boxId="parseInt($route.params.bid, 10)"
                :boxOt="parseInt(boxOt, 10)"
                @form-page-rdy="
                  cntntNoPdn = true;
                  getScrollHeight();
                "
                :prms="
                  course.boxes
                    .filter(x => x.id == $route.params.bid)[0]
                    .forms.filter(f => f.id == $route.params.iid)[0]
                "
              />
              <template
                v-else-if="mode == 4 && boxOt == 503 && course.percent != 100"
              >
                <div class="pd-20">
                  <div class="alert alert-warning" role="alert">
                    <h4 class="alert-heading">Мэдэгдэл</h4>
                    <p>
                      Бүх хичээлийг үзэж дуусгасны дараа үнэлгээ өгөх боломжтой.
                    </p>
                  </div>
                </div>
              </template>
              
            </vue-custom-scrollbar>
            <div
              v-if="$store.state.app.isMobile & rdy && boxOt != 493"
              class="pos-fixed b-0 wd-100p"
            >
              <div class="text-center">
                <button
                  @click="mobileBtmBoxes = !mobileBtmBoxes"
                  :class="
                    `btn btn-icon ${
                      !mobileBtmBoxes ? 'btn-primary mg-b-10' : 'btn-warning'
                    } pos-relative`
                  "
                  type="button"
                >
                  <feather
                    v-if="mobileBtmBoxes"
                    type="arrow-down"
                    class="text-white"
                  ></feather>
                  <feather v-else type="plus-circle"></feather>
                  <div v-if="course.alerts.length" class="msg-ind">
                    {{ course.alerts.length }}
                  </div>
                </button>
              </div>
              <div
                v-if="mobileBtmBoxes"
                style="max-height: 70vh; overflow: auto"
                class="card card-widget card-contacts"
              >
                <div class="card-body pd-0">
                  <ul class="list-group list-group-flush">
                    <li
                      @click="tabClicked({ name: 'tab_home' })"
                      class="list-group-item"
                      :class="{ active: $route.params.bid == 0 }"
                    >
                      <feather type="home" class="wd-20-f ht-20-f"></feather>
                      <div class="list-body">
                        <h6
                          :class="
                            `${
                              $route.params.bid == 0
                                ? 'text-white'
                                : 'tx-color-02'
                            }`
                          "
                        >
                          Сургалтын агуулга
                        </h6>
                      </div>
                    </li>
                    <li
                      @click="tabClicked({ name: `tab_${box.id}` })"
                      class="list-group-item"
                      :class="{ active: $route.params.bid == box.id }"
                      v-for="(box, i) in course.boxes.filter(
                        x =>
                          (x.attaches.length || x.forms.length || x.tasks.length ) && x.ot!=114
                      )"
                      :key="i"
                    >
                      <feather
                        type="chevron-right"
                        class="wd-20-f ht-20-f"
                      ></feather>
                      <div class="list-body">
                        <h6
                          :class="
                            `${
                              $route.params.bid == box.id
                                ? 'text-white'
                                : 'tx-color-02'
                            }`
                          "
                        >
                          {{ box.nm }}
                        </h6>
                      </div>
                      <nav
                        class="nav"
                        v-if="
                          course.alerts.filter(x => x.type == box.ot).length
                        "
                      >
                        <span class="badge badge-danger"
                          >Шинэ
                          {{
                            course.alerts.filter(x => x.type == box.ot).length
                          }}</span
                        >
                      </nav>
                      <nav
                        class="nav"
                        v-else-if="
                          box.attaches.length +
                            box.forms.length +
                            box.tasks.length >
                            0
                        "
                      >
                        <span class="badge badge-secondary">{{
                          box.attaches.length +
                            box.forms.length +
                            box.tasks.length
                        }}</span>
                      </nav>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

           
            <!-- <div class="ht-55 bd-t" v-else>
              <Tabs
                v-model="editableTabsValue"
                type="border-card"
                tab-position="bottom"
                class="course-bottom-tabs"
                @tab-click="tabClicked"
              >
                <TabPane label="Эхлэл" name="tab_home">
                  <span slot="label">
                    <feather
                      type="home"
                      class="wd-16-f ht-16-f mg-r-5"
                      style="top: -2px; position: relative;"
                    ></feather>
                    <span class="tx-color-02">Эхлэл</span>
                  </span>
                </TabPane>
                <TabPane
                  v-for="(box, i) in course.boxes.filter(x=>x.attaches.length || x.forms.length || x.tasks.length)"
                  :key="i"
                  :label="`${box.nm} ${course.alerts.filter(x=>x.type==box.ot).length? course.alerts.filter(x=>x.type==box.ot).length : ''}`"
                  :name="`tab_${box.id}`"
                >
                  <span slot="label">
                    <span class="tx-color-02">{{box.nm}}</span>
                    <span
                      v-if="course.alerts.filter(x=>x.type==box.ot).length"
                      style="top: -10px; position: relative;"
                      class="badge badge-pill badge-danger text-lowecase tx-10"
                    >Шинэ {{course.alerts.filter(x=>x.type==box.ot).length}}</span>
                  </span>
                </TabPane>
              </Tabs>
            </div> -->
            <!-- <div
              @click="showRightSide=!showRightSide"
              v-if="course.i5==1"
              :class="`team-chat-toggler`"
              role="button"
            >
              <feather :type="showRightSide?'chevron-right':'chevron-left'" class="wd-20-f ht-20-f"></feather>
            </div>-->
          </div>

          <div
            v-if="showRightSide"
            class="team-chat wd-25p bd-l bg-white ht-100v"
          >
            <ul
              class="nav nav-line"
              style="height: 56px"
              id="myTab5"
              role="tablist"
            >
              <li class="nav-item pd-l-20 wd-40p" v-if="showChatBox">
                <a
                  role="button"
                  @click="rightSideActiveTab = 1"
                  class="nav-link d-flex justify-content-center align-items-center"
                  :class="{ active: rightSideActiveTab == 1 }"
                  style="height: 52px"
                >
                  <feather
                    type="message-square"
                    :stroke-width="1"
                    class="mg-r-5 mg-l-5 wd-20-f ht-20-f"
                  ></feather
                  >Чат
                </a>
              </li>
              <li class="nav-item">
                <a
                  role="button"
                  @click="rightSideActiveTab = 2"
                  style="height: 52px"
                  class="nav-link d-flex justify-content-center align-items-center"
                  :class="{ active: !showChatBox || rightSideActiveTab == 2 }"
                >
                  <feather
                    type="clipboard"
                    :stroke-width="1"
                    class="mg-r-5 mg-l-5 wd-20-f ht-20-f"
                  ></feather
                  >Тэмдэглэл
                </a>
              </li>
            </ul>
            <team-preview
              v-if="rightSideActiveTab == 1 && course.teamId > 0 && showChatBox"
              :teamId="course.teamId"
              :obj="{ title: sendObjTitle() }"
              @on-attach="onAttach"
            />
            <task-notes
              v-else-if="course.id > 0"
              :taskId="course.id"
              @on-attach="onAttach"
              :obj="{ title: sendObjTitle(), name: course.name }"
            />
          </div>
        </div>
      </div>
    </div>

    <b-sidebar v-model="sideBar.teamChat" title="Чат" shadow right width="100%">
      <div class="px-3 py-2 bg-white" v-if="sideBar.teamChat">
        <team-preview
          :teamId.sync="course.teamId"
          :obj="{ title: sendObjTitle() }"
          @on-attach="onAttach"
        />
      </div>
    </b-sidebar>

    <file-sidebar
      :id.sync="fileSidebar.id"
      :show="fileSidebar.show"
      @on-hide="
        fileSidebar.show = false;
        fileSidebar.id = 0;
      "
    />

    <re-buy-lesson
      :reBuyModal="reBuyModal"
      :itemId="parseInt($route.params.id, 10)"
      :course="course"
      :reBuyObj="reBuyObj"
      @on-hide="reBuyModal = false"
    />

    <!-- <task-detail-side
      v-if="taskDialogSide.id > 0"
      :id.sync="taskDialogSide.id"
      @on-task-close="taskDialogSide.id = 0"
    ></task-detail-side> -->

    <b-sidebar
      right
      shadow
      backdrop
      v-model="taskDialogSide.show"
      width="90vw"
      @change="visibleChanged"
      no-header
      prop
      sidebar-class="dnmcsdbr"
    >
      <div class="mg-20">
        <div class="bd bg-white rounded pd-20">
          <!-- <forum-topic
            :task="taskDialogSide.task"
            @on-detail="showDetail($event, boxObj.box.box)"
            @on-toggle-class="toggleBodyClass($event.mode, $event.class)"
          /> -->
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";

const moment = require("moment");
import { request } from "@/api/all";
var _ = require("lodash");

import "element-ui/lib/theme-chalk/index.css";
import { MessageBox, Tabs, TabPane, Notification } from "element-ui";

import { mapActions } from "vuex";
import { hasOneOf } from "@/libs/tools";
export default {
  components: {
    vueCustomScrollbar,
    Tabs,
    TabPane,
    courseHeader: () => ({
      component: import(
        "@/views/modules/lms/student/components/headerCourse.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    reBuyLesson: () => ({
      component: import("@/views/modules/lms/student/components/rebuy.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    navDynamic: () => ({
      component: import(
        "@/views/modules/lms/student/components/navDynamic.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    // courseBox: () => ({
    //   component: import("@/views/modules/lms/student/components/boxCourse.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
    zoomDetail: () => ({
      component: import("@/views/modules/lms/student/sections/zoomDetail.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    zoomWaiting: () => ({
      component: import("@/views/modules/lms/student/sections/zoomWaiting.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    teacherDetail: () => ({
      component: import(
        "@/views/modules/lms/student/sections/teacherDetail.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    teacherList: () => ({
      component: import("@/views/modules/lms/student/sections/teacherList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    lessonList: () => ({
      component: import("@/views/modules/lms/student/sections/lessonList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    zoomList: () => ({
      component: import("@/views/modules/lms/student/sections/zoomList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    formList: () => ({
      component: import("@/views/modules/lms/student/sections/formList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    formFill: () => ({
      component: import("@/components/modules/form/fill"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    forumList: () => ({
      component: import("@/views/modules/lms/student/sections/forumList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    forumTopic: () => ({
      component: import("@/views/modules/lms/student/sections/forumTopic.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    forumReply: () => ({
      component: import("@/views/modules/lms/student/sections/forumReply.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    teamPreview: () => ({
      component: import("@/components/modules/team/embed.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    taskNotes: () => ({
      component: import("@/components/task/components/notes"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    courseOverview: () => ({
      component: import("@/views/modules/lms/student/sections/aboutCourse.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    courseCertificate: () => ({
      component: import("@/views/modules/lms/student/sections/courseCertificate.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    fileSidebar: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    courseNavbar: () => ({
      component: import(
        "@/views/modules/lms/student/components/courseAndLessonDetailNav.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    assignList: () => ({
      component: import("@/views/modules/lms/student/sections/assignList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    jitsiDetail: () => ({
      component: import("@/views/modules/lms/student/sections/jitsiDetail.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    taskRating: () => ({
      component: import("@/components/task/components/actions/rate.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    taskDetailSide: () => ({
      component: import("@/components/task/detail/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
  },

  data() {
    return {
      taskDialogSide: {
        show: false,
        id: 0,
        key: 0,
        task: null,
      },

      mobileBtmBoxes: false,
      editableTabsValue: "tab_home",

      mode: 0,
      navbarMode: 0,
      sideBar: {
        teamChat: false
      },

      courseMode: {
        mode: 1,
        title: "Бүх нээлттэй сургалт"
      },
      cntntNoPdn: false,
      showRightSide: true,
      rightSideActiveTab: 1,
      showChatBox: false,
      course: {
        boxes: []
      },
      teacher: {},
      boxOt: null,
      boxObj: {
        box: {
          forms: [],
          attachments: [],
          tasks: [],
          attachmentsCount: 0,
          box: {}
        },
        rdy: false
      },
      taskObj: {
        task: {},
        rdy: false
      },
      fileSidebar: {
        show: false,
        id: 0
      },
      now: "",
      zoomIsStarted: false,
      expanded: true,
      rdy: false,
      cntntNoPdn: false,

      reBuyModal: false,
      reBuyObj: {}
    };
  },
  mounted() {
    this.toggleBodyClass("addClass", "app-course");
    require("@/assets/scss/pages/course.scss");
    //getScrollHeight
    window.addEventListener("resize", this.getScrollHeight);
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getScrollHeight);
  },
  destroyed() {
    Object.assign(this.$data, this.$options.data());
    this.toggleBodyClass("removeClass", "app-course");
    this.toggleBodyClass("removeClass", "dynamic-locker");
  },
  methods: {
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    ...mapActions(["resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    // toggleNav() {
    //   this.expanded = !this.expanded;
    // },
    // toggleRightSide()
    // {
    //   console.log('hi', this.showRightSide);
    //   this.showRightSide=!this.showRightSide;

    // },

    zoomHasNotStarted(conference) {
      request({
        api: { method: "get", url: "isintime" },
        params: {
          startDate: conference.dueStartDate,
          endDate: conference.dueDate
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          if (res.data.mode == 0) {
            this.showRightSide = false;
            this.zoomIsStarted = true;
          } else {
            this.showRightSide = true;
            this.zoomIsStarted = false;
            if (this.course.i5 == 1) this.showChatBox = true;
          }
        }
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    toggleTeamChat() {
      this.sideBar.teamChat = true;
    },
    init() {
      //console.log('course init fired', this.$route.name);
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "v2/Learn/CheckIsJoined" },
        params: { courseId: this.$route.params.id },
        //this.$route.name == "lmsLessonView" ? this.$route.params.cid : this.$route.params.id
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('lesson CheckIsJoined', res.data.result);
          switch (res.data.result) {
            case -1:
              // MessageBox({
              //   title: "Мэдэгдэл",
              //   message: "Курсэд элсээгүй байна",
              //   showConfirmButton: false
              // });
        //        this.$bvToast.toast("Курсэд элсээгүй байна", {
        //   title: "Мэдэгдэл",
        //   autoHideDelay: 3000,
        //   appendToast: true,
        //   toaster: "b-toaster-top-right"
        // });

        Notification.success({
              message: "Сургалтад элсээгүй байна.",
              title: "Мэдэгдэл",
              duration: 3000,
              type: "info",
              position: "top-right",
              offset: 50
            });

              //this.$router.push({ name: "lmsParticipant" });
              //2022-04-04 BFA redirect url-tai bolgosnoor hervee elseegui bvl elseh huudas ru shiddeg bolgov
              this.$router.push({ name: "lmsAttend", params: { id: this.$route.params.id, s1: 0, s2: 0 } });

              break; //# elseegui bgaa
            case 1:
              this.initCourse();
              break;
            case 2:
              MessageBox({
                title: "Мэдэгдэл",
                //message: "Үргэлжлэх хугацаа эхлээгүй байна",
                message: "Сургалт эхлээгүй байгаа тул хандах боломжгүй",
                showConfirmButton: false
              });
              this.$router.push({ name: "lmsParticipant" });
              break; //# ehleegui bgaa
            case 3:
              this.showRightSide = false;
              MessageBox({
                title: "Мэдэгдэл",
                message: "Сургалт дууссан тул хандах боломжгүй",
                showConfirmButton: false
              });
              this.$router.push({ name: "lmsParticipant" });
              break; //# finished course
            default:
              break;
          }
        }
      });
    },
    initCourse() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "V2/Learn/courseDetail" },
        params: { id: this.$route.params.id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('V2/Learn/courseDetail=> ', res.data.course.boxes.filter(x=>x.ot==114));
          //console.log('V2/Learn/courseDetail=> ', res.data.course.boxes);
          res.data.course.boxes.map(b => {
            if (b.ot == 114) {
              if (b.tasks.length) {
                if (this.$store.state.app.isMobile) {
                  b.tasks = b.tasks.filter(x => x.i2 != 1);
                }
                let _obj = _.maxBy(
                  b.tasks.filter(x => x.im != null),
                  function(t) {
                    return t.im.lastViewDate;
                  }
                );
                if (
                  _obj != undefined &&
                  _obj != null &&
                  _obj.id != undefined &&
                  _obj.id != null
                ) {
                  b.tasks.filter(x => x.id == _obj.id)[0].resume = true;
                }
              }
              b.icon = "menu";
            } else if (b.ot == 116) b.icon = "pen-tool";
            else if (b.ot == 124) b.icon = "message-square";
            else if (b.ot == 389) b.icon = "clipboard";
            else if (b.ot == 503) b.icon = "clipboard";
            else if (b.ot == 396) {
              b.icon = "users";
              if (b.tasks.length) {
                //# 2021.1.18 bagshiin neren deer darhaar coused elseegui bn gd 0 id ruu yavaad bhaar zassan
                res.data.course.teachers[0].boxId = b.id;

                this.teacher.has = true;
                this.teacher.profile = b.tasks[0].defaultAttachmentUrl;
                this.teacher.fullname =
                  b.tasks[0].taskEn + " " + b.tasks[0].task;
                this.teacher.info = b.tasks[0].position;
              }
            } else if (b.ot == 397) b.icon = "info";
            else if (b.ot == 493) b.icon = "video";
            else if (b.ot == 500) b.icon = "video";
          });
          this.course = res.data.course;
          this.rdy = true;
          this.$nextTick(() => {
            this.editableTabsValue = "tab_home";
            this.initCourseStatus();
            this.initAfter();
          });
        }
      });
    },
    initCourseStatus() {
      if (this.course.flag1 == 9900) {
        this.courseMode = {
          mode: 2,
          title: "Заавал хамрагдах сургалт"
        };
      } else if (this.course.isJoined) {
        var startDate = moment(this.course.date.start),
          endDate = moment(this.course.date.end),
          date = moment(this.course.date.now); //range = moment().range(startDate, endDate);
        if (date.isBetween(startDate, endDate)) {
          this.courseMode = {
            mode: 3,
            title: "Миний үзэж буй сургалт"
          };
        } else {
          this.courseMode = {
            mode: 4,
            title: "Миний дууссан сургалт"
          };
        }
        //date.now
      }
    },
    initAfter() {
      //console.log('init after fired');
      if (this.$route.params.bid > 0 && this.$route.params.iid == 0) {
        this.mode = 1;
        this.initBox(this.$route.params.bid, this.$route.params.bot);
      } else if (
        this.$route.params.bid > 0 &&
        this.$route.params.iid > 0 &&
        this.$route.params.bot == 6
      ) {
        this.mode = 2;
        //this.showAttach(this.$route.params.iid);
      }
      //# forum yed hairtsgaa oloh gd detail duudah bolov
      // else if(this.$route.params.bid>0 && this.$route.params.iid>0 && this.$route.params.bot==124){
      //   this.mode=2;
      //   this.initBox(this.$route.params.bid, this.$route.params.bot, this.$route.params.iid);
      // }
      else if (
        this.$route.params.bid > 0 &&
        this.$route.params.iid > 0 &&
        (this.$route.params.bot == 124 ||
          this.$route.params.bot == 396 ||
          this.$route.params.bot == 125 ||
          this.$route.params.bot == 493 ||
          this.$route.params.bot == 500 ||
          this.$route.params.bot == 516)
      ) {
        this.mode = 3;
        this.showTask(this.$route.params.iid);
        if (this.$route.params.bot == 124) {
          this.boxObj.box = {
            box: this.course.boxes.filter(
              x => x.id == this.$route.params.bid
            )[0]
          };
        } else if (this.$route.params.bot == 125 && this.course.i5 == 1) {
          this.showChatBox = true;
        } else if (this.$route.params.bot == 493 && this.course.i5 == 1) {
          this.showChatBox = true;
        }
      } else if (
        this.$route.params.bid > 0 &&
        this.$route.params.iid > 0 &&
        (this.$route.params.bot == 389 || this.$route.params.bot == 503)
      ) {
        this.mode = 4;
        this.boxOt = this.$route.params.bot;
      }else if(this.$route.params.bot==-7){
        //console.log('im here');
        //this.cntntNoPdn=true;
        this.mode = -7;
      } else {
        if (this.course.i5 == 1) this.showChatBox = true;
      }
    },
    initBox(boxId, bot) {
      if (bot == 502) {
        this.boxObj.rdy = true;
        if (this.course.i5 == 1) this.showChatBox = true;
      }
      this.editableTabsValue = `tab_${boxId}`;
      this.boxOt = bot;
      if (bot == 114 || bot == 124 || bot == 125 || bot == 493 || bot == 500) {
        if (this.course.i5 == 1) this.showChatBox = true;
      }

      if (bot == 114 || bot == 396 || bot == 493 || bot == 500) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "taskCore/coreBoxInTaskList" },
          data: {
            id: boxId,
            skip: 0,
            size: 100
          },
          store: this.$store
        }).then(res => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.boxObj.box = res.data;
            this.boxObj.rdy = true;
          }
        });
      } else if (
        bot == 116 ||
        bot == 124 ||
        bot == 125 ||
        bot == 389 ||
        bot == 503
      ) {
        let _ta = this.course.boxes.filter(x => x.ot == bot);
        if (bot == 116) {
          this.boxObj.box = {
            forms: _ta.length > 0 ? _ta[0].forms : [],
            box:
              this.course.boxes.filter(x => x.id == boxId).length > 0
                ? this.course.boxes.filter(x => x.id == boxId)[0]
                : []
          };
        } else if (bot == 124 || bot == 125) {
          this.boxObj.box = {
            tasks: _ta.length > 0 ? _ta[0].tasks : [],
            box: _ta.length > 0 ? _ta[0] : {}
          };
        } else if (bot == 389 || bot == 503) {
          this.boxObj.box = {
            forms: _ta.length > 0 ? _ta[0].forms : [],
            box:
              this.course.boxes.filter(x => x.id == boxId).length > 0
                ? this.course.boxes.filter(x => x.id == boxId)[0]
                : []
          };
        }
        this.boxObj.rdy = true;
      }
    },
    showTask(id) {
      this.editableTabsValue = `tab_${this.$route.params.bid}`;
      this.boxOt = this.$route.params.bot;
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "task/taskInheritedDetail" },
        params: { id: id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");

        if (res.ios != undefined && res.ios && this.$route.params.bot == 493) {
          //window.open('https://demo.gosmart.mn', '_blank');
          this.$router.push({
            name: "lmsCourseView",
            params: { id: this.$route.params.id, bid: 0, iid: 0, bot: 0 }
          });
          this.$bvToast.toast(
            `Та Динамик платформ апп-н шинэчлэлтийг татна уу. Эсвэл гар утасны броузер-с [${this.$store.state.app.activeGroup.hostPro[0]}] холбоосоор хандана уу`,
            {
              title: "Мэдэгдэл",
              autoHideDelay: 5000,
              appendToast: false,
              variant: "info",
              toaster: "b-toaster-top-center"
            }
          );
        } else {
          if (res != false) {
            if (this.$route.params.bot == 500) {
              this.zoomHasNotStarted(res.data.task);
            } else if (this.$route.params.bot == 516) {
              window.open(res.data.task.taskEn, "_blank");
              //this.init();
              //this.zoomHasNotStarted(res.data.task);
            }
            this.taskObj.task = res.data.task;
            this.taskObj.rdy = true;
          }
        }
      });
    },
    visibleChanged(e) {
      //console.log('vndsen sidebar haagdlaa');
      if (!e) {
        this.taskDialogSide.show = false;
        // Object.assign(this.$data, this.$options.data());
        // this.$emit("on-task-close");
      }
    },
    showTopicDetail(task,box){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "task/taskInheritedDetail" },
        params: { id: task.id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          this.taskDialogSide.id = task.id;
          this.taskDialogSide.task = res.data.task;
          this.taskDialogSide.show = true;
        }
      });
      
      //console.log('task,box', task, box);
    },
    showDetail(a, box) {
      if (this.boxOt == 114) {
        this.$router.push({
          name: "lmsLessonView",
          params: {
            id: a.id,
            cid: this.$route.params.id,
            bid: 0,
            iid: 0,
            bot: 0
          }
        });
      } else {
        if (a.objectTypeId == 125 ) {
          //|| a.objectTypeId == 124
          //this.showTopicDetail(a, box);

          this.$router.push({
            name: "lmsCourseView",
            params: {
              id: this.$route.params.id,
              bid: box.id,
              iid: a.id,
              bot: 125
            }
          });
        } else {
          //console.log('showDetail showDetail', a, box);
          if (box.ot != undefined && box.ot == 516) {
            window.open(a.taskEn, "_blank");
          } else {
            this.$router.push({
              name: "lmsCourseView",
              params: {
                id: this.$route.params.id,
                bid: box.id,
                iid: a.id,
                bot: box.objectTypeId
              }
            });
          }
        }
      }
    },
    showFormFill() {},
    onFormFilled(e) {
      let curBox = this.course.boxes.filter(x => x.id == e.boxId);
      if (curBox.length) {
        let curForm = curBox[0].forms.filter(x => x.id == e.id);
        if (curForm.length) {
          curForm[0].fillingCount = e.fillingCount;
        }
      }
    },
    onAttach(e) {
      this.fileSidebar.id = parseInt(e, 10);
      this.fileSidebar.show = true;
    },
    showExamResult(e) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "learn/GetExamResult" },
        params: { courseId: this.$route.params.id, examId: e },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          let _txt = "";
          if (res.data.examCode == 1) {
            _txt =
              res.data.msg +
              " " +
              ((res.data.truePoint * 100) / res.data.questionPoint).toFixed(2) +
              "%";
          } else if (res.data.examCode == 2) {
            _txt = "Шалгалтын огноо эхлээгүй/дуусаагүй байна";
          } else if (res.data.examCode == 3 || res.data.examCode == 6) {
            _txt = "Шалгалтын үр дүнг харах боломжгүй";
          } else if (res.data.examCode == 4) {
            _txt = "Шалгалтын үр дүнг илгээгээгүй";
          } else {
            _txt = "Шалгалтын өгөгдөл илгээсэн байна";
          }

          MessageBox({
            title: "Дүн харах",
            message: _txt,
            showConfirmButton: false
          });
        }
      });
    },
    sendObjTitle() {
      let rv = "";

      if (this.$route.params.iid > 0) {
        rv =
          this.course.boxes.filter(b => b.id == this.$route.params.bid)[0].nm +
          " > " +
          this.getBreadcrumbTitle();
      } else if (
        this.$route.params.bid > 0 &&
        this.course.boxes.filter(b => b.id == this.$route.params.bid).length
      ) {
        rv =
          this.course.name +
          " > " +
          this.course.boxes.filter(b => b.id == this.$route.params.bid)[0].nm;
      } else {
        rv = this.course.name;
      }

      return rv;
    },
    getBreadcrumbTitle() {
      let rv = "";
      let _b = this.course.boxes.filter(b => b.id == this.$route.params.bid);
      if (_b.length) {
        if (_b[0].tasks.length) {
          let _i = _b[0].tasks.filter(x => x.id == this.$route.params.iid);
          if (_i.length) rv = _i[0].task;
        } else if (_b[0].forms.length) {
          let _i = _b[0].forms.filter(x => x.id == this.$route.params.iid);
          if (_i.length) rv = _i[0].nm;
        } else if (_b[0].attaches.length) {
          let _i = _b[0].attaches.filter(x => x.id == this.$route.params.iid);
          if (_i.length) rv = _i[0].t != "" ? _i[0].t : _i[0].n;
        }
      }
      return rv;
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    getScrollHeight() {
      let mh = 170;
      if (screen.width <= 1024) {
        mh = 115;
      } else if (this.mode == 4) {
        mh = 115;
      }  else if (this.mode == 3) {
        mh = 115;
      } 
      else if (this.mode == -7) {
        mh = 115;
      }
      if (this.$store.state.app.isMobile) {
        mh = 60;
      }

      if (this.$store.state.app.mainLayoutConfig.expanded) {
        mh = 0;
      }

      if (this.cntntNoPdn) {
        mh = 115;
      }
      console.log('mh', mh, this.mode);

      return `calc(${window.innerHeight}px - ${mh}px) !important;`;
    },
    tabClicked(e) {
      if (e.name.split("_")[1] == "home") {
        this.$router.push({
          name: "lmsCourseView",
          params: { id: this.$route.params.id, bid: 0, iid: 0, bot: 0 }
        });
      } else {
        let curb = this.course.boxes.filter(x => x.id == e.name.split("_")[1]);
        if (curb.length) {
          this.$router.push({
            name: "lmsCourseView",
            params: {
              id: this.$route.params.id,
              bid: curb[0].id,
              iid: 0,
              bot: curb[0].ot
            }
          });
        }
      }
    },
    toggleContent(e) {
      let _obj = this.$store.state.app.mainLayoutConfig;
      if (e != undefined && e) {
        this.expanded = true;
        this.showRightSide = true;
        _obj.header = 2;
        _obj.expanded = false;
      } else {
        this.expanded = false;
        this.showRightSide = false;
        _obj.header = null;
        _obj.expanded = true;
      }
      this.handleMainLayoutConfig(_obj);
      this.$nextTick(() => {
        this.getScrollHeight();
      });
    },

    onRebuy(lesson) {
      //console.log('open rebuy');
      this.reBuyObj = lesson;
      this.reBuyModal = true;
    }
  },
  watch: {
    "$root.$route"() {
      let _tmp = this.$data.expanded;
      let _tmpRight = this.$data.showRightSide;
      Object.assign(this.$data, this.$options.data());
      this.$data.expanded = _tmp;
      this.$data.showRightSide = _tmpRight;
      //console.log('newRoute.params', newRoute.params);
      //if(newRoute.params.cid!=oldRoute.params.cid){
      this.$nextTick(() => {
        this.init();
      });
      //}

      // this.$nextTick(() => {
      //   this.init();
      // });
    }
  }
};
</script>

<style lang="scss">
.msg-ind {
  display: flex;
  width: 20px;
  height: 20px;
  justify-content: center;
  position: absolute;
  top: -6px;
  right: -8px;
  background-color: #dc3545;
  color: #fff;
  font-size: 10px;
  font-weight: 400;
  font-family: sans-serif;
  line-height: 2;
  border-radius: 100%;
}
.dnmcsdbr{
  top: 60px !important;
  
}
</style>
